/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserAliasPatternPartTransform = 'No' | 'Lowercase' | 'Uppercase' | 'Titlecase';

export const UserAliasPatternPartTransform = {
    No: 'No' as UserAliasPatternPartTransform,
    Lowercase: 'Lowercase' as UserAliasPatternPartTransform,
    Uppercase: 'Uppercase' as UserAliasPatternPartTransform,
    Titlecase: 'Titlecase' as UserAliasPatternPartTransform
};

